var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewHeaderDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 85 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i69ijtt52a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1,
    width: 82.029,
    height: 59.4,
    rx: 4.714,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fill: "#000",
    d: "M9.043 9.486h26.4v3.771h-26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fill: "#000",
    d: "M9.043 16.086h47.143v1.886H9.043z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.514,
    y: 25.986,
    width: 66.943,
    height: 17.914,
    rx: 1.414,
    stroke: "#EEE",
    strokeWidth: 0.943
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.514,
    y: 49.557,
    width: 66.943,
    height: 17.914,
    rx: 1.414,
    stroke: "#EEE",
    strokeWidth: 0.943
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.03,
    y: 0.53,
    width: 82.969,
    height: 60.34,
    rx: 5.184,
    stroke: "#EBECEE",
    strokeWidth: 0.94
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i69ijtt52a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1,
    width: 82.029,
    height: 59.4,
    rx: 4.714,
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewHeaderDefault);
export default __webpack_public_path__ + "static/media/ViewHeaderDefault.aaf25216.svg";
export { ForwardRef as ReactComponent };